const React = require('react');
const T = require('prop-types');
const { alpha } = require('@mui/material/styles');
const { default: Fab } = require('@mui/material/Fab');
const { default: Stack } = require('@mui/material/Stack');
const { default: Tooltip } = require('@mui/material/Tooltip');
const { default: Styled } = require('styled-components');
const { default: CameraIcon } = require('@mui/icons-material/CameraAlt');
const { default: CropIcon } = require('@mui/icons-material/Crop');
const { default: UploadIcon } = require('@mui/icons-material/Publish');

const internals = {};

function ProfilePhotoActions(props) {
    const {
        canEditPhoto = false,
        disabled = false,
        onCapture,
        onEdit,
        onUpload,
        showCamera = true,
        showUpload = true
    } = props;

    const {
        ActionButton,
        ActionsOverlay
    } = internals;

    return <ActionsOverlay aria-label='Profile photo actions'>
        <Stack direction='row' spacing={0.8}>
            {canEditPhoto && (
                <Tooltip arrow title='Edit crop' placement='bottom'>
                    <span>
                        <ActionButton
                            color='primary'
                            size='small'
                            onClick={onEdit}
                            disabled={disabled}
                            aria-label='Edit profile photo crop'
                        >
                            <CropIcon />
                        </ActionButton>
                    </span>
                </Tooltip>
            )}
            {showUpload && (
                <Tooltip arrow title='Upload profile photo' placement='bottom'>
                    <span>
                        <ActionButton
                            color='primary'
                            size='small'
                            onClick={onUpload}
                            disabled={disabled}
                            aria-label='Upload profile photo'
                        >
                            <UploadIcon />
                        </ActionButton>
                    </span>
                </Tooltip>
            )}
            {showCamera && (
                <Tooltip arrow title='Take profile photo' placement='bottom'>
                    <span>
                        <ActionButton
                            color='primary'
                            size='small'
                            onClick={onCapture}
                            disabled={disabled}
                            aria-label='Take profile photo'
                        >
                            <CameraIcon />
                        </ActionButton>
                    </span>
                </Tooltip>
            )}
        </Stack>
    </ActionsOverlay>;
}

ProfilePhotoActions.propTypes = {
    canEditPhoto: T.bool,
    disabled: T.bool,
    onCapture: T.func,
    onEdit: T.func,
    onUpload: T.func.isRequired,
    showCamera: T.bool,
    showUpload: T.bool
};


module.exports = ProfilePhotoActions;

internals.ActionsOverlay = Styled.nav`
    position: absolute;
    z-index: 2;
    right: ${({ theme }) => theme.spacing(1.25)};
    bottom: ${({ theme }) => theme.spacing(1.25)};
    padding: ${({ theme }) => `${theme.spacing(0.6)} ${theme.spacing(0.9)}`};
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.18)};
`;

internals.ActionButton = Styled(Fab)`
    && {
        width: 35px;
        min-width: 35px;
        height: 35px;
        min-height: 35px;
        box-shadow: none;
    }

    && svg {
        width: 19px;
        height: 19px;
        fill: currentColor;
    }
`;
